const REGION_OPTIONS = [
  { value: 'alaska', label: 'Alaska' },
  { value: 'albuquerque', label: 'Albuquerque' },
  { value: 'asheville', label: 'Asheville' },
  { value: 'atlantaMetro', label: 'Atlanta Metro' },
  { value: 'austinSanAntonio', label: 'Austin-San Antonio' },
  { value: 'bayArea', label: 'Bay Area' },
  { value: 'birminghamTuscaloosa', label: 'Birmingham - Tuscaloosa' },
  { value: 'boston', label: 'Boston' },
  { value: 'bowlingGreen', label: 'Bowling Green' },
  { value: 'buffalo', label: 'Buffalo' },
  { value: 'californiaCentralValley', label: 'California Central Valley' },
  { value: 'capeCod', label: 'Cape Cod' },
  { value: 'cascadiaCoast', label: 'Cascadia Coast' },
  { value: 'centralCoast', label: 'Central Coast' },
  { value: 'centralGeorgia', label: 'Central Georgia' },
  { value: 'centralIllinois', label: 'Central Illinois' },
  { value: 'centralMichigan', label: 'Central Michigan' },
  { value: 'centralMissouri', label: 'Central Missouri' },
  { value: 'centralNewYork', label: 'Central New York' },
  { value: 'centralPennsylvania', label: 'Central Pennsylvania' },
  { value: 'centralSouthDakota', label: 'Central South Dakota' },
  { value: 'charleston', label: 'Charleston' },
  { value: 'charlotteMetro', label: 'Charlotte Metro' },
  { value: 'chattanooga', label: 'Chattanooga' },
  { value: 'chesapeakeBay', label: 'Chesapeake Bay' },
  { value: 'chicago', label: 'Chicago' },
  { value: 'cincinnati', label: 'Cincinnati' },
  { value: 'cleveland', label: 'Cleveland' },
  { value: 'columbus', label: 'Columbus' },
  { value: 'connecticut', label: 'Connecticut' },
  { value: 'dallas', label: 'Dallas' },
  { value: 'dayton', label: 'Dayton' },
  { value: 'dc', label: 'DC' },
  { value: 'denver', label: 'Denver' },
  { value: 'desMoines', label: 'Des Moines' },
  { value: 'detroit', label: 'Detroit' },
  { value: 'duluthNorthernMinnesota', label: 'Duluth - Northern Minnesota' },
  { value: 'eastTexas', label: 'East Texas' },
  { value: 'easternIdaho', label: 'Eastern Idaho' },
  { value: 'easternIowa', label: 'Eastern Iowa' },
  { value: 'easternKentucky', label: 'Eastern Kentucky' },
  { value: 'easternNorthCarolina', label: 'Eastern North Carolina' },
  { value: 'eauClaireLaCrosse', label: 'Eau Claire - La Crosse' },
  { value: 'evansville', label: 'Evansville' },
  { value: 'fargoGrandForks', label: 'Fargo-Grand Forks' },
  { value: 'fortWayne', label: 'Fort Wayne' },
  { value: 'grandRapidsLansing', label: 'Grand Rapids - Lansing' },
  { value: 'greenBayMichiganUP', label: 'Green Bay and Michigan Upper Peninsula' },
  { value: 'greensboro', label: 'Greensboro' },
  { value: 'greenville', label: 'Greenville' },
  { value: 'hamptonRoads', label: 'Hampton Roads' },
  { value: 'harrisburg', label: 'Harrisburg' },
  { value: 'hawaii', label: 'Hawaii' },
  { value: 'houston', label: 'Houston' },
  { value: 'huntsville', label: 'Huntsville' },
  { value: 'indianapolis', label: 'Indianapolis' },
  { value: 'inlandNorthwest', label: 'Inland Northwest' },
  { value: 'jacksonNatchez', label: 'Jackson-Natchez' },
  { value: 'jacksonville', label: 'Jacksonville' },
  { value: 'kansasCity', label: 'Kansas City' },
  { value: 'knoxville', label: 'Knoxville' },
  { value: 'lasVegas', label: 'Las Vegas' },
  { value: 'lexington', label: 'Lexington' },
  { value: 'littleRock', label: 'Little Rock' },
  { value: 'losAngeles', label: 'Los Angeles' },
  { value: 'louisville', label: 'Louisville' },
  { value: 'madison', label: 'Madison' },
  { value: 'memphis', label: 'Memphis' },
  { value: 'miami', label: 'Miami' },
  { value: 'milwaukee', label: 'Milwaukee' },
  { value: 'mobileTallahassee', label: 'Mobile - Tallahassee' },
  { value: 'montana', label: 'Montana' },
  { value: 'montgomery', label: 'Montgomery' },
  { value: 'nashville', label: 'Nashville' },
  { value: 'newOrleansBatonRouge', label: 'New Orleans - Baton Rouge' },
  { value: 'newYork', label: 'New York' },
  { value: 'newYorkCapitalRegion', label: 'New York Capital Region' },
  { value: 'northeasternPennsylvania', label: 'Northeastern Pennsylvania' },
  { value: 'northernIowa', label: 'Northern Iowa' },
  { value: 'northernMaine', label: 'Northern Maine' },
  { value: 'northernMichigan', label: 'Northern Michigan' },
  { value: 'northernMissouri', label: 'Northern Missouri' },
  { value: 'northwestArkansas', label: 'Northwest Arkansas' },
  { value: 'ohioRiverValley', label: 'Ohio River Valley' },
  { value: 'ohioMississippiValley', label: 'Ohio-Mississippi Valley' },
  { value: 'oklahomaCity', label: 'Oklahoma City' },
  { value: 'omaha', label: 'Omaha' },
  { value: 'orlando', label: 'Orlando' },
  { value: 'philadelphia', label: 'Philadelphia' },
  { value: 'phoenix', label: 'Phoenix' },
  { value: 'pittsburgh', label: 'Pittsburgh' },
  { value: 'portland', label: 'Portland' },
  { value: 'portlandAugusta', label: 'Portland - Augusta' },
  { value: 'providence', label: 'Providence' },
  { value: 'raleighDurham', label: 'Raleigh-Durham' },
  { value: 'rapidCity', label: 'Rapid City' },
  { value: 'reno', label: 'Reno' },
  { value: 'richmond', label: 'Richmond' },
  { value: 'rochesterNY', label: 'Rochester NY' },
  { value: 'rochesterSouthernMinnesota', label: 'Rochester-Southern Minnesota' },
  { value: 'saltLake', label: 'Salt Lake' },
  { value: 'sanDiego', label: 'San Diego' },
  { value: 'savannahGA', label: 'Savannah, GA' },
  { value: 'seattle', label: 'Seattle' },
  { value: 'shenandoahValley', label: 'Shenandoah Valley' },
  { value: 'shreveport', label: 'Shreveport' },
  { value: 'siouxCitySiouxFalls', label: 'Sioux City - Sioux Falls' },
  { value: 'southGeorgia', label: 'South Georgia' },
  { value: 'southernNewMexico', label: 'Southern New Mexico' },
  { value: 'southwestVirginia', label: 'Southwest Virginia' },
  { value: 'southwesternMissouri', label: 'Southwestern Missouri' },
  { value: 'stLouis', label: 'St. Louis' },
  { value: 'tampa', label: 'Tampa' },
  { value: 'texasPanhandleSouthPlains', label: 'Texas Panhandle-South Plains' },
  { value: 'toledo', label: 'Toledo' },
  { value: 'tulsa', label: 'Tulsa' },
  { value: 'twinCities', label: 'Twin Cities' },
  { value: 'upperNewYork', label: 'Upper New York' },
  { value: 'vermontNewHampshire', label: 'Vermont + New Hampshire' },
  { value: 'westTexas', label: 'West Texas' },
  { value: 'westVirginia', label: 'West Virginia' },
  { value: 'westernColorado', label: 'Western Colorado' },
  { value: 'westernKansas', label: 'Western Kansas' },
  { value: 'westernMassachusetts', label: 'Western Massachusetts' },
  { value: 'westernNebraska', label: 'Western Nebraska' },
  { value: 'westernNorthDakota', label: 'Western North Dakota' },
  { value: 'westernOklahoma', label: 'Western Oklahoma' },
  { value: 'wichita', label: 'Wichita' },
  { value: 'wyoming', label: 'Wyoming' },
  { value: 'europe', label: 'Europe' },
  { value: 'latinAmerica', label: 'Latin America' },
  { value: 'africa', label: 'Africa' },
  { value: 'asia', label: 'Asia' },
  { value: 'australiaOceania', label: 'Australia/Oceania' },
  { value: 'other', label: 'Other' },
].sort((a, b) => a.label.localeCompare(b.label));

export { REGION_OPTIONS };
